<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :btn-loading="isSubmitting"
    :submit-btn-disabled="isSubmitting"
    :max-width="800"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Truck Type Link</span>
    </template>
    <template slot="body">
      <v-form ref="form">
        <v-row>
          <v-col
            cols="5"
            class="pb-0"
          >
            <v-autocomplete
              v-model="item.truck_schedule_truck_type_id"
              :items="truckTypes"
              item-text="name"
              item-value="id"
              prepend-icon="mdi-truck"
              :rules="[(v) => !!v || 'Truck Type is required']"
            >
              <template slot="label">
                Truck Type<RedAsterisk />
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="2"
            class="pb-0 d-flex align-center justify-center"
          >
            <v-icon
              color="grey darken-1"
              large
            >
              mdi-link-variant
            </v-icon>
          </v-col>
          <v-col
            cols="5"
            class="pb-0"
          >
            <v-autocomplete
              v-model="item.linked_truck_schedule_truck_type_id"
              :items="linkedTruckTypes"
              item-text="name"
              item-value="id"
              prepend-icon="mdi-truck"
              :rules="[(v) => !!v || 'Linked Truck Type is required']"
            >
              <template slot="label">
                Linked Truck Type<RedAsterisk />
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </the-dialog-box>
</template>

<script>

export default {
  props: {
    truckTypes: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    item: null,
    isSubmitting: false,
    itemDto: {
      id: 0,
      truck_schedule_truck_type_id: null,
      linked_truck_schedule_truck_type_id: null,
    },
  }),
  computed: {
    linkedTruckTypes() {
      if (!this.item || !this.item.truck_schedule_truck_type_id) return this.truckTypes;
      return this.truckTypes.filter((truckType) => truckType.id !== this.item.truck_schedule_truck_type_id);
    },
  },
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {
    async submit() {
      if (this.isSubmitting) return false;
      if (!this.item) return false;
      if (this.$refs.form && !this.$refs.form.validate()) return false;

      if (this.item.truck_schedule_truck_type_id === this.item.linked_truck_schedule_truck_type_id) {
        this.$bus.$emit('showError', 'A Truck Type cannot link to itself');
        return false;
      }

      this.isSubmitting = true;
      try {
        let res;
        if (this.item.id) {
          res = await this.$api.truckScheduleTruckTypeLinkedTruckType.update(this.item);
        } else {
          res = await this.$api.truckScheduleTruckTypeLinkedTruckType.store(this.item);
        }

        this.$bus.$emit('showSuccess');
        this.$emit('success');
        return res;
      } catch (error) {
        this.$bus.$emit('showError', error.message || 'Unable to save truck type link');
        return false;
      } finally {
        this.isSubmitting = false;
      }
    },

    open(item = null) {
      if (item && item.id) {
        this.item = {
          id: item.id,
          truck_schedule_truck_type_id: item.truck_schedule_truck_type_id,
          linked_truck_schedule_truck_type_id: item.linked_truck_schedule_truck_type_id,
        };
      } else {
        this.item = { ...this.itemDto };
      }

      this.$refs.dialogBox.open();
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
  },
};
</script>
